import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Form from 'react-bootstrap/Form';
import { useEnv } from '../../../../context/env-context';
import { useAuth } from '../../../../hooks/useAuth';
import { makeRequest } from '../../../../utils/makeRequest';
import { toast } from 'react-toastify';
import { NumericFormat } from 'react-number-format';

function ReportsDODModalForm({ setSpinner, close, createReport }) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [institutions, setInstitutions] = useState(null);

  const [institutionId, setInstitutionId] = useState('');
  const [numberOfDays, setNumberOfDays] = useState(100);

  const getInstitutions = async () => {
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    setSpinner(true);
    const config = { token, url: `${apiOriginConsumer}/get_institutions`, method: 'GET' };

    try {
      const response = await makeRequest(config);

      setInstitutions(response);
    } catch (error) {
      toast.error(`Failed getting institutions: ${error.message}`);
    } finally {
      setSpinner(false);
    }
  };

  useEffect(() => {
    (async () => {
      setSpinner(true);
      await getInstitutions();
      setSpinner(false);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => createReport({ institutionId, days: numberOfDays });

  return (
    <>
      <Row className="align-items-center">
        <Col md={4} className="bo-same-line">
          <Form.Label>Institution:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <Form.Select
            className="bo-filter bo-w-250"
            value={institutionId}
            onChange={e => setInstitutionId(e.target.value)}
          >
            <option value="">All Institutions</option>
            {institutions &&
              Object.entries(institutions)
                .sort(([, a], [, b]) => a.localeCompare(b))
                .map(([key, value]) => (
                  <option key={key} value={key}>
                    {value}
                  </option>
                ))}
          </Form.Select>
        </Col>
      </Row>
      <Row className="mt-2 align-items-start">
        <Col md={4} className="bo-same-line">
          <Form.Label>Number of Days:</Form.Label>
        </Col>
        <Col md={8} className="bo-same-line">
          <NumericFormat
            customInput={Form.Control}
            className="bo-input bo-w-250"
            type="text"
            value={numberOfDays}
            onValueChange={({ floatValue }) => setNumberOfDays(floatValue)}
            allowNegative={false}
            decimalScale={0}
          />
        </Col>
      </Row>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button className="bo-button" onClick={handleCreate}>
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsDODModalForm;
